import {
  AppBar,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MessageIcon from "@mui/icons-material/Message";
import "./dataMapTable.scss";
import Buttons from "../../Controls/Buttons/Button";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

const QCComment = ({
  comment: commentFromData,
  addComment,
  deleteComment,
  role,
  isReadOnly,
  parameterIndex,
  heading,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [open, setOpen] = useState();
  const [comment, setComment] = useState(commentFromData);

  useEffect(() => {
    setOpen(modalOpen);
    setComment(commentFromData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  const onClickComment = (index) => {
    setModalOpen(true);
  };

  const handleCloseDialog = () => {
    setModalOpen(false);
    // setComment("")
  };

  const handleSubmit = (comment) => {
    if (comment.trim() !== "") {
      addComment(parameterIndex, comment);
      setModalOpen(false);
    }
  };

  const handleDeleteComment = () => {
    deleteComment(parameterIndex);
    setModalOpen(false);
  };

  // const label = { inputProps: { "aria-label": "Checkbox demo" } };

  return (
    <>
      <div className="checkbox-wrap">
        {
          isReadOnly && commentFromData === "" ? (
            <ChatBubbleOutlineIcon
              sx={{
                color: "gray",
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            />
          ) : commentFromData === "" ? (
            <AddCommentIcon onClick={(e) => onClickComment()} />
          ) : (
            <MessageIcon onClick={(e) => onClickComment()} color="primary" />
          )
          // ) :
          // comment === "" ? (
          //   <AddCommentIcon onClick={(e) => onClickComment()} />
          // ) : (
          //   <MessageIcon onClick={(e) => onClickComment()} color="primary" />
          // )
        }
      </div>
      <div>
        <Dialog
          fullWidth
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          size="lg"
          className="reject-modal"
        >
          <AppBar className="appbar" position="static" elevation={0}>
            <Toolbar
              className="appbar"
              sx={{
                minHeight: "50px !important", // Set the desired height
                padding: "0 6px", // Adjust padding to control spacing
              }}
            >
              <Typography variant="h6" sx={{ flex: 1 }}>
                {heading}
              </Typography>
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleCloseDialog}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent className="processor-dailogContent">
            <TextField
              multiline
              minRows={5} // Minimum number of visible rows
              fullWidth
              variant="outlined"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              // disabled={isReadOnly}
              inputProps={{
                readOnly: isReadOnly, // Make the field non-editable instead of disabling it
              }}
              sx={{ marginTop: 2 }}
              placeholder="Enter your comment here..."
            />
          </DialogContent>

          <DialogActions>
            <div className="btn-wrap">
              {commentFromData !== "" && (
                <Buttons
                  className="clear-btn"
                  variant="outlined"
                  onClick={(event) => handleDeleteComment("")}
                  text="Delete"
                  disabled={commentFromData === "" || isReadOnly}
                />
              )}
              <Buttons
                className="clear-btn"
                variant="outlined"
                onClick={(event) => setComment("")}
                text="Clear"
                disabled={comment === "" || isReadOnly}
              />

              <Buttons
                className="reject-btn"
                variant="outlined"
                text="Submit"
                disabled={
                  comment === "" || isReadOnly || commentFromData === comment
                }
                onClick={(e) => handleSubmit(comment)}
              />
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

QCComment.defaultProps = {
  operation: "edit",
  comment: "",
};

export default QCComment;
